<template>
  <!-- 案件詳細 -->
  <div id="CpapInstrumentRequestDetailEdit">
    <div id="item-contens">
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">案件情報</span>
        <table>
        <tr><th>申込日時</th><td>{{data.applicationDate}} {{data.applicationTime}}  {{data.applicationUserName}}</td></tr>
        <tr><th>受付番号</th><td>{{data.receiptNumber}}</td></tr>
        <tr v-if="quotationActive"><th>見積コード</th>
          <td>
            <input type="text" style="width:730px;" name="見積コード" validate="required" disabled />
            <b-button style="margin-left:10px; width:150px; height:27px;" @click="quotationModalActive=true">見積選択</b-button>
          </td>
        </tr>
        <tr><th>申込み状況</th>
          <td>
          <span class="tag is-warning" style="height:30px;margin-left:5px;width:20%;">
            申込中
          </span>
          </td>
          </tr>
        </table>
      </div>
      <div class="card-content margin-top">
        <span style="font-size:20px;">医療機関情報</span>
          <table>
          <tr><th>医療機関名</th><td>{{data.hospitalName}}</td></tr>
          <tr><th>医師名</th><td><input type="text" v-model="data.doctorName" maxlength="256" /></td></tr>
          <tr><th>事務担当者名</th><td><input type="text" v-model="data.clerkName" maxlength="256" /></td></tr>
          <tr><th>機種<span class="require"/></th><td><select></select></td></tr>
          <tr><th>台数<span class="require"/></th><td><input type="text" v-model="data.count" maxlength="256" /></td></tr>
          <tr>
            <th>加温加湿器</th>
            <td>
              <div>
                <b-radio class="td_radio" :native-value="true">あり</b-radio>
                <b-radio class="td_radio" :native-value="false">なし</b-radio>
              </div>
            </td>
          </tr>
          <tr>
            <th>通信モジュール</th>
            <td>
              <div>
                <b-radio class="td_radio" :native-value="true">あり</b-radio>
                <b-radio class="td_radio" :native-value="false">なし</b-radio>
              </div>
            </td>
          </tr>
          <tr><th>【マスク】</th></tr>
          <tr><th>個数<span class="require"/></th><td><input type="text" v-model="data.count" maxlength="256" /></td></tr>
          <tr><th>種類</th><td><input type="text" maxlength="256" /></td></tr>
          <tr><th>フレームサイズ</th><td><input type="text" maxlength="256" /></td></tr>
          <tr><th>クッションサイズ</th><td><input type="text" maxlength="256" /></td></tr>
          <tr><th>【機器納品先】</th></tr>
          <tr>
            <th>郵便番号<span class="require"/></th>
            <td>
              <!-- NOTE: v-modelが設定されていなかったため、バリデーションのためにdata配下にpostalCodeを定義しています。 -->
              <input
                style="width: 270px;"
                name="機器納品先の郵便番号"
                validate="required|numeric"
                maxlength="7"
                v-model="postalCode"
                :class="{'border-red': invalidPostcode}"
                :placeholder="postcodePlaceholder"
              />
              <b-button style="margin-left:10px; width:150px; height:27px;" v-on:click="addressSearch('device',reqParams.zip)">郵便番号検索</b-button>
              <div v-show="invalidPostcode" class="text-red">{{ invalidNumberMessage }}</div>
            </td>
            </tr>
          <tr><th>住所<span class="require"/></th><td><input type="text" name="機器納品先の住所" validate="required" maxlength="280"/></td></tr>
          <tr><th>住所（丁目、番地）<span class="require"/></th><td><input type="text" name="機器納品先の住所（丁目、番地）" validate="required" maxlength="256"/></td></tr>
          <tr><th>住所（建物名、号室）</th><td><input type="text" maxlength="256"/></td></tr>
          <tr><th>宛名<span class="require"/></th><td><input type="text" v-model="data.receiverName" maxlength="256" /></td></tr>
          <tr>
            <th>連絡先(電話番号)<span class="require"/></th>
            <td>
              <input
                type="text"
                v-model="data.phone"
                maxlength="256"
                :class="{'border-red': invalidPhoneNumber}"
                :placeholder="phonePlaceholder"
              />
              <div v-show="invalidPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
            </td>
          </tr>
          <tr><th>発送</th><td><b-checkbox class="cstmCheckBox" value="true"></b-checkbox>川越から直送する</td></tr>
          </table>
      </div>
      <div class="card-content margin-top">
        <span style="font-size:20px;">その他</span>
        <table>
          <tr>
            <th>備考</th>
            <td>
              <textarea maxlength="256" style="resize:vertical;max-width:100%;height:120px"></textarea>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <b-modal :active.sync="quotationModalActive" has-modal-card>
      <quotationSelectModal :selectStatus="extUserStatus.registed" title="見積選択" labelForOrg="品目名称" :belongs="data.belongsId" :institutionId="data.belongsId" @select="setQuotation"></quotationSelectModal>
    </b-modal>
  </div>
</template>
<script>
import {
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder,
  extUserStatus
} from "@/components/mock/base/const.js";
import QuotationSelectModal from "@/components/mock/philips/common/QuotationSelectModal";

export default {
  name: "CpapInstrumentRequestDetailEdit",
  props: ["data", "quotationActive"],
  methods: {
    setQuotation: function() {
    },
  },
  data() {
    return {
      extUserStatus: extUserStatus,
      quotationModalActive: false,
      postalCode: "",
      // 半角数字エラーメッセージ表示
      invalidPostcode: false,
      invalidPhoneNumber: false,
    };
  },
  computed: {
    // 半角数字エラーテンプレートメッセージ
    invalidNumberMessage() {
      return invalidNumberMessage;
    },
    // 郵便番号入力におけるプレースフォルダー
    postcodePlaceholder() {
      return postcodePlaceholder;
    },
    // 電話番号入力におけるプレースフォルダー
    phonePlaceholder() {
      return phonePlaceholder;
    },
  },
  components: {
    quotationSelectModal: QuotationSelectModal,
  },
  watch: {
    "postalCode"(newValue) {
      this.invalidPostcode = isNaN(Number(newValue));
    },
    "data.phone"(newValue) {
      this.invalidPhoneNumber = isNaN(Number(newValue));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/mock/common/CpapInstrumentRequestDetailEdit.vue